module.exports = __webpack_public_path__ + "img/d-fbom-tai.a9c94fe9.gif";